// @flow
type TAuth = {
    eventDate?: string,
    gameName?: string,
};
type TGameType = {
    gameType?: number,
};

type TAuthState = {
    data: TAuth,
};
const initialState: TAuthState = {
    data: {
        eventDate: '',
        gameName: '',
    },
};
type TSetRegistrationData = {payload: {eventDate: string, gameName: string}, type: 'SET_REGISTRATION_DATA'};

function authReducer(state: TAuthState = initialState, {type, payload}: TSetRegistrationData) {
    switch (type) {
        case 'SET_REGISTRATION_DATA':
            return {
                ...state,
                data: {
                    ...state.data,
                    eventDate: payload.eventDate,
                    gameName: payload.gameName,
                },
            };
        case 'SET_GAME_TYPE_DATA':
            return {
                ...state,
                data: {
                    ...state.data,
                    gameType: payload.gameType,
                },
            };
        default:
            return state;
    }
}

export {authReducer};
export type {TSetRegistrationData, TAuthState, TAuth, TGameType};
